import { Divider, List, ListItemButton, Menu, MenuItem, Typography } from "@mui/material";
import { LockKeyholeOpenIcon, LogOutIcon, User2Icon } from "lucide-react";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChangePasswordDialog } from "./change-password-dialog";
import { UserContext } from "../contexts/UserContext";

export default function AccountMenu({ email }: { email: string }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] = useState(false);

  const navigate = useNavigate();
  const { setCurrentUser } = useContext(UserContext);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setCurrentUser(null);
    navigate('/');
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogOpen = () => {
    setChangePasswordDialogOpen(true);
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setChangePasswordDialogOpen(false);
    setAnchorEl(null);
  };

  return (
    <div className="absolute text-left p-4 hover:bg-gray-700 flex gap-1 bottom-0 left-0 w-64">
      <ChangePasswordDialog open={changePasswordDialogOpen} onClose={handleDialogClose} />

      <List
        component="nav"
        aria-label="account settings"
        className="w-full"
      >
        <ListItemButton
          id="account-settings"
          aria-haspopup="listbox"
          aria-controls="account-menu"
          aria-label="account"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
          className="flex items-center gap-6 hover:bg-gray-700 bg-gray-800"
        >
          <User2Icon />
          <Typography>{email}</Typography>
        </ListItemButton>
      </List>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
      >
        <Typography className="text-center py-2">Foxrest v1.0.7</Typography>
        <Divider />
        <MenuItem
          onClick={handleDialogOpen}
          className="flex items-center gap-2 hover:bg-gray-700 bg-gray-800"
        >
          <LockKeyholeOpenIcon />
          Change Password
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleLogout}
          className="flex items-center gap-2 hover:bg-gray-700 bg-gray-800"
        >
          <LogOutIcon />
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}